import collectionApiClient, {
  CollectionStats,
  OrderGraphPeriod,
} from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useAllCollectionsStatsQuery = (
  period: OrderGraphPeriod = OrderGraphPeriod.WEEK,
) => {
  return useKlydoQuery<CollectionStats>({
    queryKey: ['allCollectionsStats', period],
    queryFn: () => collectionApiClient.getAllCollectionsStats(period),
  });
};

export default useAllCollectionsStatsQuery;
